import React from "react";
import "./Footer.css";
import twitterIcon from "../../Assets/images/twitter.webp";
import instaIcon from "../../Assets/images/insta.svg";
import telegramIcon from "../../Assets/images/telegram.webp";
import fbIcon from "../../Assets/images/facebook.webp";
import ytIcon from "../../Assets/images/youtube.webp";
import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/24/solid";
import { MapPinIcon } from "@heroicons/react/24/solid";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer   flex flex-wrap overflow-hidden border-t-2 border-gray-100">
      <div className="container  ">
        <div className="footer_inner_row">
          <a href="/" aria-current="page" className="footer_logo_wrapper "></a>
        </div>

        <div className="footer_copyright_wrapper flex flex-wrap justify-center gap-3 md:gap-2 md:justify-between items-center mt-1 sm:mt-0">
          <div className="footer_copyright_text text-center sm:text-left bg-gradient-to-br from-yellow-500 via-blue-500 to-blue-400 inline-block text-transparent bg-clip-text">
            Contact us on :- <br></br>
            <div className="flex flex-col gap-y-1 mt-2">
              <a
                href="mailto:developer@ex-bit.ai"
                className="hover:underline flex items-center ml-1 text-gray-400"
              >
                <EnvelopeIcon className="w-5 h-5 mr-2 text-blue-500" />
                developer@ex-bit.ai
              </a>
              <a
                href="mailto:hello@ex-bit.ai"
                className="hover:underline flex items-center ml-1 text-gray-400"
              >
                <EnvelopeIcon className="w-5 h-5 mr-2 text-blue-500" />
                hello@ex-bit.ai
              </a>
              <a
                href="mailto:admin@ex-bit.ai"
                className="hover:underline flex items-center ml-1 text-gray-400"
              >
                <EnvelopeIcon className="w-5 h-5 mr-2 text-blue-500" />
                admin@ex-bit.ai
              </a>
            </div>
          </div>
          {/* <div className="footer_copyright_text text-center  text-gray-400 flex flex-col ">
            Contact us on :-{" "}
            <a
              href="mailto:admin@ex-bit.ai"
              className="hover:underline ml-1 bg-gradient-to-br from-yellow-500 via-blue-500 to-blue-400 inline-block text-transparent bg-clip-text"
            >
              admin@ex-bit.ai
            </a>
            
          </div> */}

          <div className="footer_copyright_text   text-gray-400 max-w-md  ">
            <div className="flex flex-col items-center  sm:items-start text-center sm:text-left ">
              <MapPinIcon className="w-5 h-5 mr-2 text-blue-500 mb-2 " />
              <div>
              202/237, Village No. 9, Nongprue Subdistrict, Banglamung District,
              Chonburi Province Thailand
              </div>
              
            </div>

            <div className="flex mt-2 text-center sm:text-left justify-center sm:justify-start ">
              <PhoneIcon className="w-5 h-5 mr-2 text-blue-500" />
              <a
                href="tel:+9112345678911"
                className="hover:underline text-gray-400 text-center sm:text-left"
              >
                +971509863643
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="container  mt-2">
        <div className="footer_inner_row">
          <a href="/" aria-current="page" className="footer_logo_wrapper "></a>
        </div>
        <div className="footer_seperator flex flex-row items-center justify-center pb-0 pt-2 relative">
          <div className="footer-seperator-line"></div>
        </div>
        <div className="footer_copyright_wrapper flex flex-wrap justify-center gap-3 md:gap-2 md:justify-between items-center mt-1 sm:mt-0">
          <div className="footer_copyright_text text-center sm:text-left bg-gradient-to-br from-yellow-500 via-blue-500 to-blue-400 inline-block text-transparent bg-clip-text">
            © {currentYear} ExBit. All rights reserved
          </div>
          {/* <div className="footer_copyright_text text-center  text-gray-400 ">
            Contact us on :-{" "}
            <a
              href="mailto:admin@ex-bit.ai"
              className="hover:underline ml-1 bg-gradient-to-br from-yellow-500 via-blue-500 to-blue-400 inline-block text-transparent bg-clip-text"
            >
              admin@ex-bit.ai
            </a>
          </div> */}

          <div className="community_icon_wrapper pb-5 ml-9 sm:ml-0">
            <div className="icon-holder">
              <a
                href="https://x.com/ExBit_official"
                target="_blank"
                className="icon_wrapper inline-block"
              >
                <img
                  className="h-auto w-5 ftr-icon invert"
                  src={twitterIcon}
                  alt="Twitter"
                />
              </a>
            </div>
            <div className="icon-holder">
              <a
                href="https://www.youtube.com/@ExBit_official"
                target="_blank"
                className="icon_wrapper inline-block"
              >
                <img
                  className="h-auto w-6 ftr-icon invert"
                  src={ytIcon}
                  alt="Yt"
                />
              </a>
            </div>

            <div className="icon-holder">
              <a
                href="https://www.instagram.com/ExBit_ai/"
                target="_blank"
                className="icon_wrapper inline-block"
              >
                <img
                  className="h-auto w-6 ftr-icon"
                  src={instaIcon}
                  alt="Instagram"
                />
              </a>
            </div>

            <div className="icon-holder">
              <a
                href="https://t.me/ExBitofficial24"
                target="_blank"
                className="icon_wrapper inline-block"
              >
                <img
                  className="h-auto w-6 ftr-icon invert"
                  src={telegramIcon}
                  alt="Telegram"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
